import {
  AfterViewInit,
  Component,
  inject,
  NgZone,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime, filter, Subject } from "rxjs";

import { ViewConfig } from "@app/commons/utils/view-config";
import {
  AllPageSizes,
  DocumentDivisions,
  DocumentPageCategories,
  GenerativeDocumentSearchDataStorage,
  PageConfigDefault,
  SearchFilter,
  SortOrder,
} from "@app/commons/types/enums/constants.enums";
import {
  IDocument,
  IDocumentFilter,
  IDocumentListResponse,
  states,
  dealerTypes,
  IGenerativeBusinessDocumentDTO,
} from "@app/commons/types/interfaces/documents.interface";
import { IDataFilter } from "@app/commons/types/interfaces/filters.interfaces";
import { DocumentService } from "@app/services/document.service";
import {
  formatBytes,
  getBooleanToYesNo,
  getErrorMessage,
} from "@app/commons/utils/utils";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DocumentFilterModalComponent } from "../../document-filter-modal/document-filter-modal.component";
import { LocalStorageCacheService } from "@app/services/local-storage-cache.service";
import { formControlsNames } from "../../constants";
import { DataService } from "@app/services/data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-document-list",
  templateUrl: "./document-list.component.html",
  styleUrl: "./document-list.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class DocumentListComponent implements OnInit, AfterViewInit {
  searchPlaceholder = "Search Documents";

  /* Pagination values */
  viewConfig = new ViewConfig();
  page: number | PageConfigDefault = PageConfigDefault.PageLimit;
  pageSize = PageConfigDefault.PageSize;
  collectionSize: null | number = null;
  documents: IDocument[] | undefined;
  allPageSizes = Object.keys(AllPageSizes).filter((key) => !isNaN(Number(key)));
  /* Pagination values */

  allGenDocuments: IGenerativeBusinessDocumentDTO[] = [];
  genDocuments: IGenerativeBusinessDocumentDTO[] = [];
  nextPageToken: string | undefined;
  summary: string | undefined;
  isGenerativeSearch: boolean = false;

  /** Search values */
  today: string = "";
  searchForm: FormGroup = new FormGroup({});
  searchValue = "";
  disableSearchButton = false;
  searchSubject = new Subject<string>();
  documentDivisions = DocumentDivisions;
  documentTypes = [];
  searchBoxClass = "";
  states = states;
  dealerTypes = dealerTypes;
  /** Search values */

  isFilterSearch = true;

  /** Filters */
  modalService = inject(NgbModal);

  allFilters: IDocumentFilter[] = [
    {
      type: "multiselect",
      formControlName: "documentType",
      label: "Document Type",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "ownerName",
      label: "Owner/Individual Name",
    },
    {
      type: "text",
      formControlName: "name",
      label: "File Name",
    },
    {
      type: "multiselect",
      formControlName: "documentType",
      label: "Document Type",
    },
    {
      type: "date",
      formControlName: "dateOfFiling",
      label: "Date of Filing",
    },
    {
      type: "text",
      formControlName: "streetAddress",
      label: "Street Address",
    },
    {
      type: "text",
      formControlName: "city",
      label: "City",
    },
    {
      type: "state",
      formControlName: "state",
      label: "State",
    },
    {
      type: "date",
      formControlName: "receivedByDate",
      label: "Received By Date",
    },
    {
      type: "text",
      formControlName: "filingNumber",
      label: "Filing Number",
    },
    {
      type: "text",
      formControlName: "businessId",
      label: "Business ID",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "date",
      formControlName: "expirationDate",
      label: "Expiration Date",
    },
    {
      type: "range",
      formControlName: "expirationDate",
      label: "Expiration Date Range",
    },
    {
      type: "text",
      formControlName: "incorporator",
      label: "Incorporator",
    },
    {
      type: "text",
      formControlName: "comissionNumber",
      label: "Commission #",
    },
    {
      type: "text",
      formControlName: "registrationNumber",
      label: "Registration Number",
    },
    {
      type: "text",
      formControlName: "secRegistrationNumber",
      label: "SEC Registration Number",
    },
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "dealerId",
      label: "Dealer ID",
    },
    {
      type: "dealerType",
      formControlName: "dealerType",
      label: "Dealer Type",
    },
    {
      type: "text",
      formControlName: "county",
      label: "County",
    },
    {
      type: "date",
      formControlName: "issueDate",
      label: "Issue Date",
    },
    {
      type: "range",
      formControlName: "issueDate",
      label: "Issue Date Range",
    },
    {
      type: "date",
      formControlName: "expirationDate",
      label: "Expiration Date",
    },
    {
      type: "range",
      formControlName: "expirationDate",
      label: "Expiration Date Range",
    },
  ];

  businessFilters = [
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "businessId",
      label: "Business ID",
    },
    {
      type: "range",
      formControlName: "dateOfFiling",
      label: "Date of Filing Range",
    },
  ];

  adsdFilters = [
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "dealerId",
      label: "Dealer ID",
    },
    {
      type: "text",
      formControlName: "dealerType",
      label: "Dealer Type",
    },
  ];

  defaultFilters = [
    {
      type: "text",
      formControlName: "businessName",
      label: "Business/Company Name",
    },
    {
      type: "text",
      formControlName: "ownerName",
      label: "Owner/Individual Name",
    },
    {
      type: "range",
      formControlName: "dateOfFiling",
      label: "Date of Filing Range",
    },
  ];
  securityFilters = [...this.defaultFilters];
  filledFields: IDocumentFilter[] = [];
  settingFormFromOldValues = false;

  getBooleanToYesNo = getBooleanToYesNo;
  formatBytes = formatBytes;
  documentFilterModal!: NgbModalRef;

  currentDocumentFilter = "";

  constructor(
    private documentService: DocumentService,
    private dataService: LocalStorageCacheService,
    private zone: NgZone,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // Read initial pageSize from URL
    this.route.queryParams.subscribe((params) => {
      const from = params["from"];

      if (from != "sidebar") {
        this.page = this.dataService.get("page") || PageConfigDefault.PageLimit;
        this.pageSize =
          this.dataService.get("pageSize") || PageConfigDefault.PageSize;
      }
    });
  }

  ngAfterViewInit(): void {}

  ngAfterContentInit(): void {
    const oldSearchText: any = this.dataService.get("lastSearchText");
    console.log(oldSearchText);
    if (oldSearchText) {
      this.searchValue = oldSearchText;
    }
    const oldSearchValues = this.dataService.get("lastSearchForm");
    if (oldSearchValues) {
      this.settingFormFromOldValues = true;
      this.searchForm.setValue(oldSearchValues);
    }
    const savedPage: number | null = this.dataService.get(
      GenerativeDocumentSearchDataStorage.PAGE
    );
    const savedResults: IGenerativeBusinessDocumentDTO[] | null =
      this.dataService.get(GenerativeDocumentSearchDataStorage.RESULTS);
    const savedSummary: string | null = this.dataService.get(
      GenerativeDocumentSearchDataStorage.SUMMARY
    );
    const nextPageToken: string | null = this.dataService.get(
      GenerativeDocumentSearchDataStorage.NEXT_PAGE_TOKEN
    );
    const fromFilter = this.dataService.get('fromFilter') || false;
    if (!fromFilter && savedResults && savedResults.length > 0) {
      this.isGenerativeSearch = true;
      this.allGenDocuments = savedResults;
      this.page = savedPage !== null ? savedPage : PageConfigDefault.PageLimit;
      this.summary = savedSummary ?? "";
      this.nextPageToken = nextPageToken ? nextPageToken : undefined;
      this.isFilterSearch = false;
      this.updateDisplayedDocuments();
    } else {
      this.getDocuments();
    }
    this.setFilterPlaceholderValue();

    this.searchSubject
      .pipe(debounceTime(SearchFilter.DebounceTime))
      .subscribe((searchValue) => {
        if (searchValue.length >= 3) {
          this.isFilterSearch ? this.getDocuments() : this.getAIDocuments();
        } else if (searchValue.length === 0) {
          this.clearGenAiSearch();
        }
      });
    // load documentTypes
    this.loadDocumentTypes();
  }

  setFilterPlaceholderValue() {
    this.searchPlaceholder = this.isFilterSearch
      ? "Search Documents"
      : "Semantic Search";
  }

  setFilterPlaceholder() {
    this.searchValue = "";
    this.setFilterPlaceholderValue();
    this.clearFilter();
  }

  /**
   * Bootstrap only handles Arrow keys / Esc on keydown for dropdowns; Enter/Space
   * must trigger the same path as a pointer click (delegated click handler on document).
   * Defer .click() so we are outside this keydown turn and Popper/menu can attach.
   * data-bs-display="static" keeps the menu usable inside an input-group.
   */
  onFilterSearchDropdownKeydown(event: Event): void {
    const e = event as KeyboardEvent;
    if (e.repeat) {
      return;
    }
    const isOpenKey =
      e.key === "Enter" ||
      e.key === " " ||
      e.key === "Spacebar" ||
      e.code === "Space";
    if (!isOpenKey) {
      return;
    }
    e.preventDefault();
    const toggle = document.getElementById(
      "filterSearchDropdown",
    ) as HTMLButtonElement | null;
    if (!toggle) {
      return;
    }
    setTimeout(() => {
      toggle.click();
    }, 0);
  }

  useFilterSeach() {
    this.isFilterSearch = true;
    this.setFilterPlaceholder();
  }

  useSemanticSearch() {
    this.isFilterSearch = false;
    this.isGenerativeSearch = true;
    this.setFilterPlaceholder();
  }

  loadDocumentTypes() {
    this.documentService.getDocumentTypes().subscribe((data) => {
      this.documentTypes = data;
    });
  }

  ngOnInit(): void {
    const currentDate = new Date();
    this.today = currentDate.toISOString().split("T")[0];
    this.searchForm = new FormGroup({});
    formControlsNames.forEach((controlName) => {
      this.searchForm.addControl(controlName, new FormControl(""));
    });
    this.searchForm.valueChanges.subscribe(this.setSearchButton.bind(this));
  }

  setSearchButton(value: any) {
    this.disableSearchButton = true;
    Object.keys(value).forEach((key: string) => {
      if (typeof value[key] === "string" && value[key]) {
        this.disableSearchButton = false;
      } else if (value[key].length > 0) {
        this.disableSearchButton = false;
      }
    });
    if (this.disableSearchButton) {
      this.getDocuments();
    }
  }

  resetOnDivisionChange(value: string[]) {
    const currentValues = this.searchFormValue;
    if (!this.settingFormFromOldValues) {
      let formValues: any = {};
      const allFilters = [
        ...this.adsdFilters,
        ...this.businessFilters,
        ...this.securityFilters,
      ];
      this.filledFields = [];
      formControlsNames.forEach((key: string) => {
        if (currentValues[key]) {
          allFilters.forEach((element) => {
            if (
              element.formControlName === key &&
              !this.filledFields.includes(element)
            ) {
              this.filledFields.unshift(element);
            }
          });
          formValues[key] = currentValues[key];
        } else {
          formValues[key] = "";
        }
      });
      delete formValues["documentCategory"];
      this.searchForm.patchValue(formValues);
    } else {
      this.settingFormFromOldValues = false;
    }
  }

  onFilterDocuments($event: Event) {
    this.searchSubject.next(this.searchValue);
  }

  onSearch() {
    this.setPageAndPageSize(
      PageConfigDefault.PageSize,
      PageConfigDefault.PageLimit
    );
    this.getDocuments();
  }

  getDocuments() {
    this.isGenerativeSearch = false;
    const filter: IDataFilter = {
      sortColumn: "seqNumber",
      sortOrder: SortOrder.DESC,
      page: this.page < 0 ? PageConfigDefault.PageLimit : this.page,
      pageSize: this.pageSize,
      search: encodeURIComponent(JSON.stringify(this.searchFormValue)),
      fullSearch: String(this.searchValue),
      fieldsToBeSearch: JSON.stringify(
        this.selectedFilledFilters.map((element) => element.formControlName)
      ),
    };
    const filterJson = JSON.stringify(filter);
    if (
      this.currentDocumentFilter === "" ||
      this.currentDocumentFilter != filterJson
    ) {
      this.currentDocumentFilter = filterJson;
      this.viewConfig.setLoading(true);
      this.dataService.set("lastSearchForm", this.searchFormValue);
      this.dataService.set("lastSearchText", filter.fullSearch);
      this.documentService.getDocuments(filter).subscribe({
        next: (result: IDocumentListResponse) => {
          this.viewConfig.setLoading(false);
          this.documents = result.data;
          this.collectionSize = result.total;
          if (!this.documents.length) {
            this.viewConfig.setNoData(true);
          }
        },
        error: (e) => {
          this.viewConfig.setError(getErrorMessage(e));
        },
      });
    }
  }

  getAIDocuments(token: string | undefined = undefined) {
    const filter: IDataFilter = {
      sortColumn: "seqNumber",
      sortOrder: SortOrder.DESC,
      page: this.page,
      pageSize: this.pageSize,
      search: encodeURIComponent(JSON.stringify(this.searchFormValue)),
      fullSearch: String(this.searchValue),
      fieldsToBeSearch: JSON.stringify(
        this.selectedFilledFilters.map((element) => element.formControlName)
      ),
      nextPageToken: token ?? "",
    };
    this.viewConfig.setLoading(true);
    this.dataService.set("lastSearchText", filter.fullSearch);
    this.documentService.getAIDocuments(filter).subscribe({
      next: (result: any) => {
        this.viewConfig.setLoading(false);
        const newGenDocuments = result.generatedResults;

        if (token) {
          this.allGenDocuments = [...this.allGenDocuments, ...newGenDocuments];
        } else {
          this.allGenDocuments = newGenDocuments;
          this.page = PageConfigDefault.PageLimit;
        }

        this.updateDisplayedDocuments();

        this.nextPageToken = result.nextPageToken;
        this.summary = result.generatedAnswer;
        this.isGenerativeSearch = true;

        this.dataService.set(
          GenerativeDocumentSearchDataStorage.NEXT_PAGE_TOKEN,
          this.nextPageToken
        );

        this.dataService.set(
          GenerativeDocumentSearchDataStorage.PAGE,
          this.page
        );
        this.dataService.set(
          GenerativeDocumentSearchDataStorage.RESULTS,
          this.allGenDocuments
        );
        this.dataService.set(
          GenerativeDocumentSearchDataStorage.SUMMARY,
          this.summary
        );
      },
      error: (e) => {
        this.viewConfig.setError(getErrorMessage(e));
        this.viewConfig.setLoading(false);
      },
    });
  }

  private updateDisplayedDocuments() {
    const startIndex = (this.page - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.genDocuments = this.allGenDocuments.slice(startIndex, endIndex);
  }

  async goNextGenAIDocuments() {
    const nextStartIndex = this.page * this.pageSize;
    if (nextStartIndex < this.allGenDocuments.length) {
      this.page++;
      this.updateDisplayedDocuments();
      this.dataService.set(GenerativeDocumentSearchDataStorage.PAGE, this.page); // Save new page
    } else if (this.nextPageToken) {
      this.page++;
      await this.getAIDocuments(this.nextPageToken);
    } else {
      console.log("No more documents to load.");
    }
  }

  goPreviousGenAIDocuments() {
    if (this.page > 0) {
      this.page--;
      this.updateDisplayedDocuments();
      this.dataService.set(GenerativeDocumentSearchDataStorage.PAGE, this.page); // Save new page
    } else {
      console.log("Already on the first page.");
    }
  }

  goToDocumentAI(doc: IGenerativeBusinessDocumentDTO) {
    this.dataService.set('fromFilter', false);
    this.isFilterSearch = false;
    this.isGenerativeSearch = true;
    this.zone.run(() => {
      this.router.navigateByUrl(this.getRedirectUrl(doc));
    });
  }

  getRedirectUrl(doc: IGenerativeBusinessDocumentDTO) {
    return `documents/${doc.documentId || doc.id}?pageNumber=${doc.pageNumber}`;
  }

  /** Sync list state when opening a document from this list. */
  onDocumentLinkClick(doc: any): void {
    this.dataService.set('fromFilter', true);
    this.isFilterSearch = true;
    this.isGenerativeSearch = false;
  }

  /** Real URL for the anchor so Enter / open-in-new-tab work; RouterLink alone can leave activation flaky. */
  getDocumentHref(doc: any): string {
    const id = doc.documentId || doc.id;
    const pageNumber = doc.pageNumber != null ? doc.pageNumber : 1;
    return this.router.serializeUrl(
      this.router.createUrlTree(['/documents', id], {
        queryParams: { pageNumber },
      }),
    );
  }

  /**
   * SPA navigation in the same tab; allow modified clicks to follow href (new tab, etc.).
   * Enter synthesizes a click and lands here — ensure we navigate when not opening a new tab.
   */
  openDocumentFromUserEvent(event: Event, doc: any): void {
    this.onDocumentLinkClick(doc);
    const e = event as MouseEvent;
    if (
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey ||
      e.button === 1
    ) {
      return;
    }
    event.preventDefault();
    void this.router.navigate(['/documents', doc.documentId || doc.id], {
      queryParams: {
        pageNumber: doc.pageNumber != null ? doc.pageNumber : 1,
      },
    });
  }

  /**
   * Enter / Space on a link: ensure navigation (some screen readers / tables
   * do not synthesize a click; Space otherwise scrolls the page).
   */
  onDocumentLinkActivateKeydown(event: Event, doc: any): void {
    const e = event as KeyboardEvent;
    if (e.key !== " " && e.key !== "Enter") {
      return;
    }
    e.preventDefault();
    this.onDocumentLinkClick(doc);
    void this.router.navigate(["/documents", doc.documentId || doc.id], {
      queryParams: {
        pageNumber: doc.pageNumber != null ? doc.pageNumber : 1,
      },
    });
  }

  /** Mouse: same as following href; focus table after browser applies the hash. */
  onSkipToResultsTableClick(event: MouseEvent): void {
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }
    queueMicrotask(() => this.activateSkipToDocumentSearchTable());
  }

  /**
   * Enter / Space: match `href="#document-search-results-table"` (Space does not
   * activate links by default).
   */
  onSkipToResultsTableKeydown(event: Event): void {
    const e = event as KeyboardEvent;
    if (e.key !== "Enter" && e.key !== " ") {
      return;
    }
    e.preventDefault();
    this.activateSkipToDocumentSearchTable();
  }

  private activateSkipToDocumentSearchTable(): void {
    const id = "document-search-results-table";
    const hash = `#${id}`;
    if (typeof window !== "undefined" && window.location.hash !== hash) {
      window.location.hash = hash;
    }
    const el = document.getElementById(id);
    if (!el) {
      return;
    }
    el.scrollIntoView({ block: "start", behavior: "smooth" });
    queueMicrotask(() => el.focus());
  }

  refreshData() {
    this.setPageAndPageSize(this.pageSize, this.page);
    this.getDocuments();
  }

  setPageAndPageSize(pageSize: number, page: number) {
    this.page = page;
    this.pageSize = pageSize;
    this.dataService.set("pageSize", pageSize);
    this.dataService.set("page", page);
  }

  get searchFormValue() {
    return this.searchForm.value;
  }

  get isDivisionBusiness() {
    return this.searchFormValue.documentCategory.includes(
      DocumentPageCategories.BUSINESS_SERVICES
    );
  }

  get isDivisionSecurity() {
    return this.searchFormValue.documentCategory.includes(
      DocumentPageCategories.SECURITIES
    );
  }

  get isDivisionADSD() {
    return this.searchFormValue.documentCategory.includes(
      DocumentPageCategories.AUTO_DEALERS
    );
  }

  get isDivisionUnknown() {
    return this.searchFormValue.documentCategory.includes(
      DocumentPageCategories.UNKNOWN
    );
  }

  get isMultipleDivisionSelected() {
    let trueCount = 0;
    if (this.isDivisionBusiness) trueCount++;
    if (this.isDivisionSecurity) trueCount++;
    if (this.isDivisionADSD) trueCount++;
    return trueCount > 1;
  }

  get selectedFilters(): IDocumentFilter[] | null {
    return this.dataService.get("defaultFilters")
      ? this.dataService.get("defaultFilters")
      : this.defaultFilters;
  }

  set selectedFilters(filters: IDocumentFilter[]) {
    this.dataService.set("defaultFilters", filters);
    this.defaultFilters = filters;
  }

  setFilters(
    filters: IDocumentFilter[],
    filter: IDocumentFilter,
    isRemoved: boolean
  ) {
    this.selectedFilters = filters;
    if (isRemoved) {
      this.searchForm.controls[filter.formControlName].setValue("");
    }
  }

  addFilters() {
    this.documentFilterModal = this.modalService.open(
      DocumentFilterModalComponent,
      {
        size: "xl",
        backdrop: "static",
      }
    );
    this.documentFilterModal.componentInstance.selectedFilters =
      this.selectedFilters;
    this.documentFilterModal.componentInstance.selectedDivision =
      this.searchFormValue.documentCategory;
    this.documentFilterModal.componentInstance.setFilters =
      this.setFilters.bind(this);
  }

  trackDocument(index: number, document: any): any {
    return document.seqNumber;
  }

  trackInput(index: number, input: any): any {
    return input.formControlName;
  }

  getControl(controlName: string) {
    return this.searchForm.controls[controlName] as FormControl;
  }

  highlightSearchBox(action: string) {
    if (action === "focus") {
      this.searchBoxClass = "highlight";
    } else {
      this.searchBoxClass = "";
    }
  }

  getUniqueValues(array: IDocumentFilter[]): IDocumentFilter[] {
    const uniqueArray = array.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.label === value.label)
    );
    return uniqueArray;
  }

  get selectedFilledFilters(): IDocumentFilter[] {
    // return this.getUniqueValues(this.allFilters);
    const selectedFilterObject: any = {};
    this.selectedFilters?.forEach((element) => {
      selectedFilterObject[element.formControlName] = element;
    });
    const filledFields = this.filledFields;
    filledFields.forEach((field, index) => {
      if (selectedFilterObject[field.formControlName]) {
        filledFields.splice(index, 1);
      }
    });
    const selectedFiltersArr = this.selectedFilters ? this.selectedFilters : [];
    return [...filledFields, ...selectedFiltersArr];
  }

  clearFilter(): void {
    this.setPageAndPageSize(
      PageConfigDefault.PageSize,
      PageConfigDefault.PageLimit
    );
    this.searchValue = "";
    formControlsNames.forEach((key: string) => {
      this.searchForm.controls[key].setValue("");
    });
    this.selectedFilters = this.defaultFilters;
  }

  splitContent(content: string | undefined): string {
    if (content) {
      return content.substring(0, 300) + "...";
    }
    return "";
  }

  clearGenAiSearch() {
    this.dataService.remove("lastSearchText");
    this.dataService.remove("lastSearchForm");
    if (this.isGenerativeSearch) {
      this.searchValue = "";
      this.allGenDocuments = [];
      this.summary = "";
      this.isGenerativeSearch = false;
      this.dataService.remove(GenerativeDocumentSearchDataStorage.PAGE);
      this.dataService.remove(GenerativeDocumentSearchDataStorage.RESULTS);
      this.dataService.remove(
        GenerativeDocumentSearchDataStorage.SELECTED_RESULT
      );
      this.dataService.remove(
        GenerativeDocumentSearchDataStorage.SELECTED_PAGE
      );
      this.dataService.remove(GenerativeDocumentSearchDataStorage.SUMMARY);
      this.dataService.remove(
        GenerativeDocumentSearchDataStorage.NEXT_PAGE_TOKEN
      );
    } else {
      this.clearFilter();
      this.getDocuments();
    }
  }
}
